import Mailbox from '@src/main/modules/messages/ui/mailbox/views/mailbox/Mailbox';

const MessagesMailboxPage = () => <Mailbox />;

export default MessagesMailboxPage;
